import { genericOAuthClient, organizationClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

import { API_V1_PREFIX } from "./api-client";

export const authClient = createAuthClient({
  baseURL: `${window.__APP_CONFIG__?.apiBaseUrl || import.meta.env.VITE_API_BASE_URL || "http://localhost:4011"}${API_V1_PREFIX}/auth`,
  fetchOptions: {
    credentials: "include",
  },
  plugins: [organizationClient(), genericOAuthClient()],
});
